import {ICONS} from "patient-ping-remedy/packages/icon";
import IconButton from "patient-ping-remedy/packages/icon-button";
import {useRosterStore} from "@/store/roster_store";
import {useNotifications} from "@/hooks/useNotifications";
import {useContext} from "react";
import {useWebSocketSubscription} from "@/hooks/useWebSocketSubscription";
import {useAuthStore} from "@/store/auth_store";
import {CarecoApiContext} from "@/app-context/careco-api-context";
import {useQueryClient} from "@tanstack/react-query";

export default function NotificationsWidgetIcon() {
  const currentRoster = useRosterStore((state) => state.currentRoster);
  const currentUser = useAuthStore((state) => state.currentUser);
  const {webSocketApi} = useContext(CarecoApiContext);
  const queryClient = useQueryClient();

  const handleNewNotification = () => {
    void queryClient.invalidateQueries({ queryKey: ['notifications', true] });
    void queryClient.invalidateQueries({ queryKey: ['notifications', false] });
    void queryClient.invalidateQueries({ queryKey: ['careJourneys', currentRoster?.id] });
  };

  useWebSocketSubscription(
    () => {
      if (currentUser && currentRoster) {
        return webSocketApi?.subscribeToNotifications(currentUser.id, currentRoster.id, handleNewNotification);
      }
    },
    [currentUser, currentRoster],
    [currentRoster],
  );

  const {totalUnreadNotifications} = useNotifications({
    onlyShowUnreadNotifications: true,
    onlyUpdateCount: true,
  });

  const displayTotalUnreadNotifications =
    totalUnreadNotifications === 0 ? '' :
      totalUnreadNotifications > 99 ? '99+'
        : totalUnreadNotifications;

  return (
    <IconButton
      iconClass={ICONS.bell}
      badge={displayTotalUnreadNotifications}
      overflowBackground
    />
  );
}
